module.exports = __webpack_public_path__ + "static/media/Piercing-mouth-snakebite.dc9c7678.png";